// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.custom-control-label[data-v-9bccf650] {\n  cursor: pointer;\n}\n.mdb-calendar[data-v-9bccf650]{\n      height: calc(100vh - 42px);\n}\n.delivery-badge[data-v-9bccf650]{\n  font-size: 14px;\n  box-shadow: initial!important;\n}\n.vs__selected-options[data-v-9bccf650]{\n  padding: 0!important;\n}\n.vs--single .vs__selected[data-v-9bccf650]{\n  padding-left: 0!important;margin-left: 0!important;\n}\n\n\n", ""]);
// Exports
module.exports = exports;
